module Pki {
    export class ByteArray {
        data: any;
    }
}